module.exports = __webpack_public_path__ + "img/uplaw_icon.b9772220.png";